@if (!(isMobile$ | async)) {
  <div #spacer class="spacer"></div>
  <div
    #main
    class="main-container"
    >
    <div
      (pointerenter)="onMouseEnter($event)"
      (pointerleave)="onMouseLeave()"
      class="main"
      >
      <div class="container">
        <div #submenu class="submenu">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </div>
      </div>
      <div class="bottom">
        <ng-container *ngTemplateOutlet="bottom"></ng-container>
      </div>
    </div>
    <button
      (click)="toggled = !toggled; hoverOpen = false"
      (pointerenter)="setMouseOverToggle(true, $event)"
      (pointerleave)="setMouseOverToggle(false, $event)"
      class="toggle"
      mat-icon-button
      >
      @if (!toggled) {
        <mat-icon>keyboard_arrow_left</mat-icon>
      }
      @if (toggled) {
        <mat-icon>menu</mat-icon>
      }
    </button>
  </div>
}
<ng-template #content>
  <ng-content select="[body]"></ng-content>
</ng-template>
<ng-template #bottom>
  <ng-content select="[bottom]"></ng-content>
</ng-template>

<ng-template #mobileMenu>
  <div [ngClass]="{ mayHaveCover: mayHaveCover }" class="mobile-container">
    <div class="mobile-spacer"></div>
    <div class="content">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </div>
</ng-template>
